import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Select } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';
import ShowFiles from './ShowFiles';
import { deleteQualityCheckItem } from '../Actions';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);
const { Option } = Select;

const FabricForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    fabricItem,
    fabricIndex,
    fabricAppend,
    fabricRemove,
    isProductColumn,
    isJobOrder,
    unregister,
  } = props;

  const dispatch = useDispatch();

  const [FileModal, SetFileModal] = useState(false);

  const fabricsTable = useSelector(
    state => state.inwardItemsForQualityCheckInputTable.fabrics
  );
  const factoryIds = useSelector(state => state.factoryIds);
  const rackIds = useSelector(state => state.rackIds);

  const fabricsArray = useMemo(() => {
    if (fabricsTable.productNames.length) {
      const productId = getValues(`fabrics[${fabricIndex}].productId`);

      const productIndex = fabricsTable.productIndexes[productId];

      if (productIndex !== undefined) {
        return fabricsTable.fabrics[productIndex].fabricNames || [];
      }
    }
    return [];
  }, [fabricsTable, watch(`fabrics[${fabricIndex}].productId`)]);

  const widthsArray = useMemo(() => {
    if (fabricsTable.fabrics.length) {
      const fabricName = getValues(`fabrics[${fabricIndex}].fabric`);

      const productId = getValues(`fabrics[${fabricIndex}].productId`);

      const productIndex = fabricsTable.productIndexes[productId];

      if (fabricsTable.fabrics[productIndex]?.widths !== undefined) {
        return fabricsTable.fabrics[productIndex].widths[fabricName] || [];
      }
    }
    return [];
  }, [
    fabricsTable,
    watch(`fabrics[${fabricIndex}].productId`),
    watch(`fabrics[${fabricIndex}].fabric`),
  ]);

  const baseColorsArray = useMemo(() => {
    if (fabricsTable.fabrics.length) {
      const fabricId = getValues(`fabrics[${fabricIndex}].fabricId`);

      const productId = getValues(`fabrics[${fabricIndex}].productId`);

      const productIndex = fabricsTable.productIndexes[productId];

      if (fabricsTable.fabrics[productIndex]?.baseColors !== undefined) {
        return fabricsTable.fabrics[productIndex].baseColors[fabricId] || [];
      }
    }
    return [];
  }, [
    fabricsTable,
    watch(`fabrics[${fabricIndex}].fabricId`),
    watch(`fabrics[${fabricIndex}].productId`),
  ]);

  const printColorsArray = useMemo(() => {
    if (fabricsTable.fabrics.length) {
      const fabricId = getValues(`fabrics[${fabricIndex}].fabricId`);

      const productId = getValues(`fabrics[${fabricIndex}].productId`);

      const baseColorId = getValues(`fabrics[${fabricIndex}].baseColorId`);

      const productIndex = fabricsTable.productIndexes[productId];

      if (
        fabricsTable.fabrics[productIndex]?.printColors[fabricId] !== undefined
      ) {
        return (
          fabricsTable.fabrics[productIndex].printColors[fabricId][
            baseColorId
          ] || []
        );
      }
    }
    return [];
  }, [
    fabricsTable,
    watch(`fabrics[${fabricIndex}].fabricId`),
    watch(`fabrics[${fabricIndex}].productId`),
    watch(`fabrics[${fabricIndex}].baseColorId`),
  ]);

  return (
    <>
      <tr>
        {isProductColumn ? (
          <td className={classes.inputTd}>
            <Controller
              name={`fabrics[${fabricIndex}].productId`}
              control={control}
              defaultValue={fabricItem.productId}
              render={({ field }) => (
                <AntSelect
                  placeholder="Select product"
                  {...field}
                  onChange={value => {
                    field.onChange(value);
                    setValue(`fabrics[${fabricIndex}].fabric`, null);
                    setValue(`fabrics[${fabricIndex}].fabricId`, null);
                    setValue(`fabrics[${fabricIndex}].baseColorId`, null);
                    setValue(`fabrics[${fabricIndex}].printColorId`, null);
                    setValue(`fabrics[${fabricIndex}].racknoId`, null);
                  }}
                >
                  {fabricsTable.productNames.map(({ product, id }) => (
                    <Option key={id} value={id}>
                      {product}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </td>
        ) : null}
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].fabric`}
            control={control}
            defaultValue={fabricItem.fabric}
            render={({ field }) => (
              <AntSelect
                placeholder="Select fabric"
                {...field}
                onChange={value => {
                  field.onChange(value);
                  setValue(`fabrics[${fabricIndex}].fabricId`, null);
                  setValue(`fabrics[${fabricIndex}].baseColorId`, null);
                  setValue(`fabrics[${fabricIndex}].printColorId`, null);
                  setValue(`fabrics[${fabricIndex}].factoryId`, null);
                  setValue(`fabrics[${fabricIndex}].racknoId`, null);
                }}
              >
                {fabricsArray.map(fabric => (
                  <Option key={fabric} value={fabric}>
                    {fabric}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].fabricId`}
            control={control}
            defaultValue={fabricItem.fabricId}
            render={({ field }) => (
              <AntSelect
                placeholder="Select width"
                {...field}
                onChange={value => {
                  field.onChange(value);
                  setValue(`fabrics[${fabricIndex}].baseColorId`, null);
                  setValue(`fabrics[${fabricIndex}].printColorId`, null);
                  setValue(`fabrics[${fabricIndex}].factoryId`, null);
                  setValue(`fabrics[${fabricIndex}].racknoId`, null);
                }}
              >
                {widthsArray.map(width => (
                  <Option key={width.id} value={width.id}>
                    {width.width}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].baseColorId`}
            control={control}
            defaultValue={fabricItem.baseColorId}
            render={({ field }) => (
              <AntSelect placeholder="Select color" {...field}>
                {baseColorsArray.map(color => (
                  <Option key={color.id} value={color.id}>
                    {color.color}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].printColorId`}
            control={control}
            defaultValue={fabricItem.printColorId}
            render={({ field }) => (
              <AntSelect placeholder="Select color" {...field}>
                {printColorsArray.map(color => (
                  <Option key={color.id} value={color.id}>
                    {color.color}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].quantity`}
            control={control}
            defaultValue={fabricItem.quantity}
            render={({ field }) => (
              <AntInput
                {...field}
                placeholder="Quantity"
                type="number"
                min={0}
                size="small"
              />
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].factoryId`}
            control={control}
            defaultValue={fabricItem.factoryId}
            render={({ field }) => (
              <AntSelect
                disabled={
                  !isJobOrder &&
                  watch(`fabrics[${fabricIndex}].condition`) === 'rejected'
                }
                placeholder="Select factory"
                {...field}
                onChange={value => {
                  field.onChange(value);
                  setValue(`fabrics[${fabricIndex}].racknoId`, null);
                }}
              >
                {factoryIds.map(factory => (
                  <Option key={factory.id} value={factory.id}>
                    {factory.name}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].racknoId`}
            control={control}
            defaultValue={fabricItem.racknoId}
            render={({ field }) => (
              <AntSelect
                disabled={
                  !isJobOrder &&
                  watch(`fabrics[${fabricIndex}].condition`) === 'rejected'
                }
                placeholder="Selecy rack"
                {...field}
              >
                {rackIds.map(rack => (
                  <Option key={rack.id} value={rack.id}>
                    {rack.rackno}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].condition`}
            control={control}
            defaultValue={fabricItem.condition}
            render={({ field }) => (
              <AntSelect
                placeholder="Select condition"
                {...field}
                onChange={value => {
                  field.onChange(value);
                  if (value === 'rejected') {
                    setValue(`fabrics[${fabricIndex}].factoryId`, null);
                    setValue(`fabrics[${fabricIndex}].racknoId`, null);
                  }
                }}
              >
                <Option key="rejected" value="rejected">
                  Rejected
                </Option>
                <Option key="accepted" value="accepted">
                  Accepted
                </Option>
                <Option key="altered" value="altered">
                  Altered
                </Option>
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`fabrics[${fabricIndex}].remark`}
            control={control}
            defaultValue={fabricItem.remark}
            render={({ field }) => <AntInput placeholder="Remark" {...field} />}
          />
        </td>
        <td className={classes.inputTd}>
          <Button onClick={() => SetFileModal(true)}>File</Button>
        </td>
        <td className={classes.inputTd}>
          <DeleteOutlined
            onClick={() => {
              const fabrics = getValues('fabrics');
              if (fabrics && fabrics.length > 1) {
                fabricRemove(fabricIndex);
                dispatch(deleteQualityCheckItem('fabrics', fabricIndex));
              }
            }}
          />
          &nbsp; &nbsp;
          <PlusCircleOutlined
            onClick={() => fabricAppend({ productId: null, fabricId: null })}
          />
        </td>
      </tr>
      {FileModal ? (
        <ShowFiles
          itemIndex={fabricIndex}
          itemType="fabrics"
          watch={watch}
          setValue={setValue}
          unregister={unregister}
          SetFileModal={SetFileModal}
        />
      ) : null}
    </>
  );
};

FabricForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
  fabricRemove: PropTypes.func.isRequired,
  fabricAppend: PropTypes.func.isRequired,
  fabricItem: PropTypes.object.isRequired,
  fabricIndex: PropTypes.number.isRequired,
  isProductColumn: PropTypes.bool,
  isJobOrder: PropTypes.bool,
};

export default withStyles(styles)(FabricForm);
